import { onBeforeMount, readonly, ref } from 'vue';
import { User } from '@/api/openapi';
import { SisenseApiService } from '@/api/user/resources/sisense';
import { useCurrentUser } from '@/composable/user/user/users';

const useSisense = () => {
  const api = new SisenseApiService();
  const sisenseAuthChecked = ref(false);

  const { currentUser, fetchCurrentUser } = useCurrentUser();

  const checkSisenseAuth = async (currentUser: User) => {
    const loggedin = await api.loggedin();
    if (loggedin.ok) {
      const loggedinJson = await loggedin.json();
      // NOTE: BCアカウントとSisenseアカウントが同じでない場合はSisenseをログアウト
      if (loggedinJson.email === currentUser.email) {
        sisenseAuthChecked.value = true;
      } else {
        await api.logout();
      }
    }
  };

  const sisenseAuthed = async () => {
    const isauth = await api.isauth();
    const isauthJson = await isauth.json();
    return isauthJson.isAuthenticated;
  };

  onBeforeMount(async () => {
    // BCとSisenseのアカウントが合致することをチェック
    await fetchCurrentUser();
    await checkSisenseAuth(currentUser.value);
  });

  return {
    sisenseAuthChecked: readonly(sisenseAuthChecked),
    sisenseAuthed,
  };
};

export {
  useSisense,
};
